import chroma from 'chroma-js';
import { useCallback } from 'react';

import './preset-colors.css';
import classNames from 'classnames';

type PresetColorsProps = {
  colors: string[];
  onSelectColor: (color: string) => void;
  label?: string;
  basic?: boolean;
};

const PresetColors = ({ colors, onSelectColor, label = 'Recent', basic = false }: PresetColorsProps) => {
  const validColors = useCallback(() => {
    // max 16 colors
    return colors
      .filter((color) => {
        return chroma.valid(color);
      })
      .slice(0, 16);
  }, [colors]);

  if (!validColors().length) {
    return null;
  }
  return (
    <div className={classNames('width-100-percent preset-colors-container', { basic })}>
      <label className="C1">{label}</label>

      <div className="flex fw-wrap preset-colors-list-container">
        {validColors().map((color, index) => (
          <button
            key={index}
            className="clear-button color-picker-preset-color square-32 radius-4"
            style={{ backgroundColor: color }}
            onClick={() => onSelectColor(color)}
          />
        ))}
      </div>
    </div>
  );
};

export default PresetColors;
